// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__3OPBR","slick-next":"CustomSlider_slick-next__34fhE"};